import DG_Modal from "../../../../custom/feedback/modal";
import Add from "./add";

const AddWeighingStationParent = ({visible, onCancel, onDatasource })=>{

    return (
        <DG_Modal visible={visible}
                  width={900}
                  onCancel={() => onCancel()}
                  title={"Tạo mới trạm cân "}
                  bodyStyle={{
                      minHeight: 100,
                      maxHeight: 600,
                      overflowY: "scroll",
                  }}
                  destroyOnClose={true}
                  okText={"Tạo mới"}
                  style={{ zIndex : 5000 }}>
            <Add onCancel={onCancel} onDatasource={onDatasource}/>
        </DG_Modal>
    )
}

export default AddWeighingStationParent
